import React from "react";
import { PropTypes } from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Cell
} from "recharts";

import "./bar.scss";

import CustomTooltip from "./customTooltip";
import Logger from "../../utils/logger";

const CustomizedAxisTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`}>
    <text
      x={0}
      y={0}
      dy={16}
      textAnchor="start"
      transform="rotate(20)"
      fill="#666"
      fontSize="11px"
    >
      {payload.value}
    </text>
  </g>
);

CustomizedAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({})
};

const LABEL_OPTIONS = (label = "%") => ({
  position: "top",
  content: props => {
    return `${Number(Number(props.value).toFixed(1)).toLocaleString(
      "es"
    )}${label}`;
  }
});

const AtresBarChart = ({
  data,
  type,
  visibles,
  dataKey = "votesPerent",
  isSenate,
  label,
  labelAbrv
}) => {
  // quitamos esc / senpara la sexta
  let unitAbrv = !isSenate ? "" : "";
  Logger.log("AtresBarChart", "nuevo render", data.slice(0, 10), "ChartData");
  if (label) {
    // unitLabel = label;
    unitAbrv = labelAbrv;
  }
  return (
    <ResponsiveContainer minHeight="226px" height="60%">
      <BarChart
        data={data.slice(0, 10)}
        margin={{ top: 15, right: 30, left: 20, bottom: 5 }}
      >
        <Tooltip
          content={<CustomTooltip unitName={unitAbrv} isSenate={isSenate} />}
        />
        <XAxis
          height={75}
          type="category"
          dataKey="partyAcronym"
          allowDataOverflow
          interval={0}
          tickMargin={-5}
          isAnimationActive={false}
          tick={<CustomizedAxisTick />}
        />
        <Bar
          dataKey={dataKey}
          fill="#8884d8"
          label={LABEL_OPTIONS(unitAbrv)}
          isAnimationActive={false}
        >
          {data.slice(0, 10).map((entry, index, arr) => {
            return (
              <Cell
                key={`${entry.partyAcronym}_${entry.votes}`}
                fill={entry.partyColor}
              />
            );
          })}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AtresBarChart;
